export default "__VITE_ASSET__31707949__"